export default __webpack_public_path__ + "static/media/first-vision.211be8c2.gif";